import React, { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const SearchWithSuggestionsPortal = ({
  searchTerm,
  onSearchChange,
  suggestions,
  onSelectSuggestion
}) => {
  const inputRef = useRef(null);
  const [coords, setCoords] = useState(null);

  useEffect(() => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setCoords({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width
      });
    }
  }, [suggestions.length]);

  return (
    <>
      <input
        ref={inputRef}
        type="text"
        className="border border-gray-300 text-blue-600 rounded px-3 py-1.5 w-full sm:w-60"
        placeholder="Search Across Column"
        value={searchTerm}
        onChange={onSearchChange}
      />

      {coords && suggestions.length > 0 &&
        createPortal(
          <ul
            className="absolute z-[99999] bg-white border border-gray-300 rounded shadow max-h-40 overflow-y-auto text-blue-600"
            style={{
              top: coords.top,
              left: coords.left,
              width: coords.width,
              position: 'absolute'
            }}
          >
            {suggestions.map((item, index) => (
              <li
                key={index}
                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                onMouseDown={() => onSelectSuggestion(item)}
              >
                {item}
              </li>
            ))}
          </ul>,
          document.body
        )}
    </>
  );
};

export default SearchWithSuggestionsPortal;
